export default __webpack_public_path__ + "static/media/BUSDe.488237bc.svg";